// This file should only contain action type constants.

export const SET_PAGE_INFO = 'SET_PAGE_INFO';
